import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../../db/banco'
import type { SubPedido } from '../../db/tipos'
import { rotuloDoMotivo } from '../../pedidos/ajustes'
import { formatarMoeda, formatarData } from '../../lib/formatos'

interface Props {
  subPedido: SubPedido
}

// Leitura pura dos itens de uma marca, sem nenhum botao de mexer. Nasceu do
// smoke dela em 2026-07-30: depois de faturado nao havia como VER o pedido --
// "Ajustar itens" some no faturamento e levava a lista junto, entao a partir
// dali ela so via o total. Vale em qualquer estado, inclusive pago e cancelado.
export default function ItensDoSubPedido({ subPedido }: Props) {
  const itens = useLiveQuery(
    () =>
      banco.itens_pedido
        .where('sub_pedido_id')
        .equals(subPedido.id)
        .filter((i) => i.apagado_em === null)
        .toArray(),
    [subPedido.id],
  )
  const produtos = useLiveQuery(
    () => banco.produtos.where('representada_id').equals(subPedido.representada_id).toArray(),
    [subPedido.representada_id],
  )
  // O historico entra junto porque e o que responde "por que este total mudou?"
  // -- a mesma pergunta que fez o PDF ganhar a tarja da devolucao.
  const ajustes = useLiveQuery(
    () =>
      banco.ajustes_pedido
        .where('sub_pedido_id')
        .equals(subPedido.id)
        .filter((a) => a.apagado_em === null)
        .toArray(),
    [subPedido.id],
  )

  const nomeProduto = (id: string) => produtos?.find((p) => p.id === id)?.descricao ?? id
  const emOrdem = [...(ajustes ?? [])].sort((a, b) => a.criado_em.localeCompare(b.criado_em))

  return (
    <div className="mt-2 space-y-2">
      <table className="text-xs w-full">
        <tbody>
          {(itens ?? []).map((item) => (
            <tr key={item.id} className="border-t border-slate-100">
              <td className="py-1 text-slate-700">{nomeProduto(item.produto_id)}</td>
              <td className="py-1 text-slate-700 text-right">{item.quantidade} un</td>
              <td className="py-1 text-slate-500 whitespace-nowrap">
                × {formatarMoeda(item.preco_unitario)}
                {item.desconto_pct > 0 && (
                  <span className="text-amber-700"> −{item.desconto_pct}%</span>
                )}
              </td>
              <td className="py-1 text-slate-700 font-medium whitespace-nowrap text-right">
                = {formatarMoeda(item.total_item)}
              </td>
            </tr>
          ))}
          {itens?.length === 0 && (
            <tr>
              <td className="py-1 text-slate-500">Nenhum item — a marca foi cancelada.</td>
            </tr>
          )}
        </tbody>
      </table>

      <p className="text-xs text-slate-700 text-right">
        Total: <strong>{formatarMoeda(subPedido.valor_total)}</strong>
      </p>

      {emOrdem.length > 0 && (
        <div className="border-t border-slate-100 pt-2 space-y-0.5">
          <h4 className="text-xs font-medium text-slate-600">O que mudou depois do envio</h4>
          {emOrdem.map((ajuste) => (
            <p key={ajuste.id} className="text-xs text-slate-500">
              {formatarData(new Date(ajuste.criado_em))} ·{' '}
              {ajuste.escopo === 'sub_pedido'
                ? 'Marca cancelada'
                : `${nomeProduto(ajuste.produto_id ?? '')}: ${ajuste.quantidade_antes ?? 0} → ${
                    ajuste.quantidade_depois ?? 0
                  } un`}{' '}
              · {rotuloDoMotivo(ajuste.motivo)}
            </p>
          ))}
        </div>
      )}
    </div>
  )
}
